import { Injectable } from "@angular/core";
import { RewardCategory, RewardStateFilterType, RewardStateType } from "@fabric-types/app-account";
import { TranslationService } from "@obg/ngx.core.content";
import { DateFormat, DateService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class RewardService {
	constructor(
		private translationService: TranslationService,
		private dateService: DateService
	) {}

	getBonusType(rewardState: RewardStateType): string {
		switch (rewardState) {
			case RewardStateType.Claimable:
				return this.translationService.getByKey("bonus.claimable");
			case RewardStateType.Active:
				return this.translationService.getByKey("bonus.active");
			case RewardStateType.Forfeited:
				return this.translationService.getByKey("bonus.forfeited");
			case RewardStateType.Expired:
				return this.translationService.getByKey("bonus.expired");
			case RewardStateType.Completed:
				return this.translationService.getByKey("bonus.completed");
			default:
				return "";
		}
	}

	getBonusCategory(rewardCategory: RewardCategory): string {
		switch (rewardCategory) {
			case RewardCategory.Bonus:
				return this.translationService.getByKey("bonus.bonus");
			case RewardCategory.Cash:
				return this.translationService.getByKey("bonus.cash");
			case RewardCategory.FreeSpins:
				return this.translationService.getByKey("bonus.freespins");
			case RewardCategory.FreeBet:
				return this.translationService.getByKey("bonus.freebet");
			case RewardCategory.RiskFreeBet:
				return this.translationService.getByKey("bonus.riskfreebet");
			case RewardCategory.PriceBoost:
				return this.translationService.getByKey("bonus.priceboost");
			case RewardCategory.Poker:
				return this.translationService.getByKey("bonus.poker");
			default:
				return "";
		}
	}

	getBonusDateTitle(rewardType: RewardStateFilterType, rewardState: RewardStateType): string {
		switch (rewardType) {
			case RewardStateFilterType.Claimable:
				return this.translationService.getByKey("bonus.expires");
			case RewardStateFilterType.Active:
				return this.translationService.getByKey("bonus.available-until");
			case RewardStateFilterType.Ended:
				if (rewardState === RewardStateType.Forfeited) {
					return this.translationService.getByKey("bonus.available-until");
				}

				return this.translationService.getByKey("bonus.expired-on");
			default:
				return "";
		}
	}

	getBonusDateContent(
		rewardType: RewardStateFilterType,
		claimableUntilDate: string | undefined,
		expiryDate: string | undefined,
		dateFormat?: DateFormat
	): string | null {
		switch (rewardType) {
			case RewardStateFilterType.Claimable:
				return this.dateService.format(claimableUntilDate, dateFormat);
			case RewardStateFilterType.Active:
			case RewardStateFilterType.Ended:
				return this.dateService.format(expiryDate || claimableUntilDate, dateFormat);
			default:
				return "";
		}
	}
}
